import t from "../../../../helpers/t";
import FormItem from "../../../../components/FormItem";
import React, {useEffect, useState} from "react";
import {getItem, setItem} from "../../../../../utils/Helper";
import {$} from "../../../../../../vendor";

const ProductsChange = (props) => {
    const {contingent, setContingent, dispatch, showNotification} = props;
    const [selectedProducts,setSelectedProducts] = useState(contingent.products);
    useEffect(() => {
        change();
    },[selectedProducts]);
    const change = () => {
        let clone = {};
        Object.assign(clone, contingent);
        let productIds = [];
        selectedProducts.map(sel => {
            productIds.push({
                id: sel.id
            });
        });
        clone.products = productIds;
        setContingent(clone);
    }
    const currentUrl = new URL(window.location.href);
    const addProducts = (product) => {
        let productIds = [];
        selectedProducts.map(sel => {
            if(sel.id !== product.id) {
                productIds.push({
                    id: sel.id
                });
            }
        });
        productIds.push({
            id: product.id
        });
        let clone = {};
        Object.assign(clone, contingent);
        clone.products = productIds;
        if(clone.description === null || clone.description === ''){
            clone.description = product.description;
        }
        if(clone.image === null || clone.image === ''){
            clone.image = product.image;
        }
        setContingent(clone);
    }
    const onRemoveProduct = (index) => {
        const newProducts = selectedProducts.slice(0);
        newProducts.splice(index, 1);
        setSelectedProducts(newProducts);
        change();
    };

    const addProduct = () => {
        if(contingent.name === ''){
            $('.contingent_name_input input').css('border-color','red');
            showNotification('warning', null,t('Please enter the following fields: ')+t('contingent_name',null,'capital'));
            return;
        }
        setItem('contingent',contingent,true);
        window.location.replace("/products/add"+currentUrl.search);
    }
    const disabled= typeof props.disabled !== 'undefined'?props.disabled:'';
    const fields =  {
        fieldMap: {
            image: {
                label: t("image"),
                number: "1",
                class: "inb-select-width-1",
                type: 'image',
                style: {maxWidth: "17%", padding: 0}
            },
            name: {
                label: t("name"),
                number: "2",
                class: "inb-select-width-3",
                type: 'default',
                style: {maxWidth: "35%", padding: 0}
            },
            description: {
                label: t('description'),
                number: "3",
                class: "inb-select-width-3",
                type: 'default',
                style: {width: "50%", padding: 0}
            }
        },
        fieldNames: [
            "image", "name", "description"
        ]
    };
    const searchParams = {
        param: "q",
        checkFields: ["name"]
    };
    return ( <>
        <FormItem
            name="products"
            type="inboomaSelect"
            id={"contingents_products_"+(typeof contingent.id !== 'undefined'?contingent.id:'new')}
            sortBy={'name'}
            sortDirection={'asc'}
            advanced={true}
            placeholder={t('select_${a}',{a:t('product')})}
            selectedItems={selectedProducts}
            setSelectedItems={setSelectedProducts}
            onChangeHandler={addProducts}
            dispatch={dispatch}
            container='product-vcard'
            multiSelect={true}
            onReset={onRemoveProduct}
            fields={fields}
            searchParams={searchParams}
            model={'product'}
            label={t('product',null,'capital')}
            disabled={disabled}
            extraFilter={{findForSelect:true,parent_id:153}}
            //helpText={t('contingent_product_help')}
            /*subAddButton={true}
            subAddButtonData={{
                class: "button beautify beautify-" + getItem('user.client_id'),
                id: "inb-c-left-bar-add-product",
                i: "fi fi-page-add",
                label: t('add_${a}',{a:t('product',null, 'capital')}),
                handler: addProduct
            }}*/
            mediumWidth={9}
            smallWidth={9}
        />
        <div className={"list-item-block-offcanvas medium-3 small-3 column"} style={{paddingTop:"25px"}}>

            {disabled==="" && <><a
            href="#"
            onClick={addProduct}
            id="inb-c-left-bar-add-contingent"
            className={"float-left button beautify beautify-" + getItem('user.client_id')}
        >
            <i className="fi fi-page-add"></i>
            <span>
              {t('add_${a}',{a:t('product',null, 'capital')})}
          </span>
        </a></>}
        </div>
    </>);
}
export default ProductsChange;